// @push.rocks scope
import * as smartpromise from '@push.rocks/smartpromise';

// pushrocks scope
export { smartpromise };

